import React from "react";
import { FiInfo } from "react-icons/fi";
import { MdWarning, MdError } from "react-icons/md";
import "./AlertBanner.css";

export type AlertBannerType = "info" | "warning" | "critical";

interface AlertBannerProps {
  /** Main message shown in the banner */
  text: React.ReactNode;
  /** Visual severity of the banner */
  type?: AlertBannerType;
  /** Optional bold title rendered above the text */
  title?: string;
  /** Optional extra content (e.g. an action button) rendered on the right */
  action?: React.ReactNode;
  /** Optional extra class names */
  className?: string;
}

const ICON_MAP: Record<AlertBannerType, React.ReactNode> = {
  info: <FiInfo />,
  warning: <MdWarning />,
  critical: <MdError />,
};

const AlertBanner: React.FC<AlertBannerProps> = ({
  text,
  type = "info",
  title,
  action,
  className = "",
}) => {
  return (
    <div className={`alert-banner alert-banner--${type} ${className}`.trim()}>
      <span className="alert-banner__icon" aria-hidden="true">
        {ICON_MAP[type]}
      </span>

      <div className="alert-banner__content">
        {title && <div className="alert-banner__title">{title}</div>}
        <div className="alert-banner__text">{text}</div>
      </div>

      {action && <div className="alert-banner__action">{action}</div>}
    </div>
  );
};

export default AlertBanner;
